import { render, staticRenderFns } from "./regist_nursing_home.vue?vue&type=template&id=e73e8e1c&scoped=true&"
import script from "./regist_nursing_home.vue?vue&type=script&lang=js&"
export * from "./regist_nursing_home.vue?vue&type=script&lang=js&"
import style0 from "./regist_nursing_home.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./regist_nursing_home.vue?vue&type=style&index=1&id=e73e8e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73e8e1c",
  null
  
)

export default component.exports